<template v-if="isShowProductRating">
  <div :class="['p-rated']">
    <div v-html="product.rating_html"></div>
  </div>
</template>

<script>
export default {
  name: "ProductRate",
  props: ["product"],
  computed: {
    isShowProductRating: function() {
      return this.$store.state.front.settings.ratingDisplay;
    }
  }
};
</script>
